import { render, staticRenderFns } from "./CollapsableCardWithBody.vue?vue&type=template&id=5c4ae461&scoped=true"
import script from "./CollapsableCardWithBody.vue?vue&type=script&lang=js"
export * from "./CollapsableCardWithBody.vue?vue&type=script&lang=js"
import style0 from "./CollapsableCardWithBody.vue?vue&type=style&index=0&id=5c4ae461&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4ae461",
  null
  
)

export default component.exports